import { LoadOrError } from "../../LoadOrError/LoadOrError";
import { PPAContractTable } from "../PPAContractPage/PPAContractTable/PPAContractTable";
import { usePPADirectDeliveryContracts } from "./hooks/usePPADirectDeliveryContracts";

function PPAContractPage() {
  const { data: contracts, isLoading, error } = usePPADirectDeliveryContracts();

  return (
    <LoadOrError error={error} loading={isLoading}>
      {contracts && <PPAContractTable contracts={contracts} />}
    </LoadOrError>
  );
}

export { PPAContractPage };
